<template>
  <!-- 首页 -->
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <navigation/> -->
    <!-- 轮播图 -->
    <div class="shuffling">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in figure" :key="item.img">
          <img :title="item.namephoto" :src="item.photo" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 课程部分 -->
    <div class="course">
      <div class="csada">
        <!-- 直播课程 -->
        <div class="Livecourses">
          <!-- <div class="classification">
            <p>直播课程</p>
            <span>全部课程分类>></span>
          </div> -->
          <!-- 视频 -->
          <!-- <ul class="Course">
            <li class="Live1">
              <img src="../assets/cut.png" alt="" />
              <div class="thevideo">
                <h4>关节脱位病人的护理</h4>
                <p class="wb">
                  为了帮助广大医生锻炼临床思维、提升 临床技能、挑战疑难病例……
                </p>
                <div class="jejq">
                  <span class="je">￥3542.00</span>
                  <div>
                    <img src="../assets/dianz.png" alt="" />
                    <p class="dzs">2534</p>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs">1.566收藏</span>
                  <button class="Buynow">立即购买</button>
                </div>
              </div>
            </li>
            <li class="Live1">
              <img src="../assets/cut.png" alt="" />
              <div class="thevideo">
                <h4>关节脱位病人的护理</h4>
                <p class="wb">
                  为了帮助广大医生锻炼临床思维、提升 临床技能、挑战疑难病例……
                </p>
                <div class="jejq">
                  <span class="je">￥3542.00</span>
                  <div>
                    <img src="../assets/dianz.png" alt="" />
                    <p class="dzs">2534</p>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs">1.566收藏</span>
                  <button class="Buynow">立即购买</button>
                </div>
              </div>
            </li>
            <li class="Live1">
              <img src="../assets/cut.png" alt="" />
              <div class="thevideo">
                <h4>关节脱位病人的护理</h4>
                <p class="wb">
                  为了帮助广大医生锻炼临床思维、提升 临床技能、挑战疑难病例……
                </p>
                <div class="jejq">
                  <span class="je">￥3542.00</span>
                  <div>
                    <img src="../assets/dianz.png" alt="" />
                    <p class="dzs">2534</p>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs">1.566收藏</span>
                  <button class="Buynow">立即购买</button>
                </div>
              </div>
            </li>
            <li class="Live1">
              <img src="../assets/cut.png" alt="" />
              <div class="thevideo">
                <h4>关节脱位病人的护理</h4>
                <p class="wb">
                  为了帮助广大医生锻炼临床思维、提升 临床技能、挑战疑难病例……
                </p>
                <div class="jejq">
                  <span class="je">￥3542.00</span>
                  <div>
                    <img src="../assets/dianz.png" alt="" />
                    <p class="dzs">2534</p>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs">1.566收藏</span>
                  <button class="Buynow">立即购买</button>
                </div>
              </div>
            </li>
          </ul> -->
          <div class="classification" style="margin-top: 23px">
            <p>课程推荐</p>
          </div>
          <!-- 视频 -->
          <ul class="Course">
            <li class="Live1" v-for="item in templa" :key="item.id">
              <!-- <img src="../assets/cut.png" alt="" /> -->
              <!-- poster='' -->
              <video
                @click="jump(item)"
                :poster="$store.state.https + item.tp"
                class="videshome"
                :src="http + item.sp"
              ></video>
              <div class="thevideo">
                <div class="theh4" @click="jump(item)">{{ item.name }}</div>
                <div class="wb" @click="jump(item)" v-html="item.kcjs"></div>
                <div class="jejq">
                  <span class="je">{{ item.jg }}</span>
                  <div>
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ item.ll }}</p>
                  </div>
                </div>
                <div class="collection">
                  <span @click="eacherpage(item.userid)" class="dzs"
                    ><img :src="http + item.lstx" alt="" />{{ item.lsxm }}</span
                  >
                  <button class="Buynow" @click="jump(item)">立即查看</button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <span class="Allcourses" @click="classification()">
            全部课程分类>>
          </span>
        </div>
      </div>
    </div>
    <div class="information">
      <div class="inform">
        <div class="inform-one">
          <div class="Theheader">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <h4>信息发布</h4>
              <div
                class="viewmore"
                v-if="notice.length !== 0"
                @click="Checkthelist()"
              >
                查看更多>>
              </div>
            </div>
            <div class="notice">
              <el-menu
                :default-active="activeIndexs"
                active-text-color="#4CCAFF"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelects"
              >
                <el-menu-item index="任务发布">
                  <i
                    style="margin-right: 10px"
                    class="iconfont gos-baobiaoxinwen"
                  >
                  </i>
                  任务发布
                </el-menu-item>
                <el-menu-item index="通知公告"
                  ><i
                    style="margin-right: 10px"
                    class="iconfont gos-gonggongguangbo"
                  ></i>
                  <span> 通知公告 </span>
                </el-menu-item>
                <el-menu-item index="新闻动态">
                  <i
                    style="margin-right: 10px"
                    class="iconfont gos-baobiaoxinwen"
                  ></i>
                  新闻动态</el-menu-item
                >
              </el-menu>
              <ul style="min-height: 294px">
                <li
                  class="change"
                  v-for="item in notice"
                  :key="item.id"
                  @click="Jumpfordetails(item.id)"
                >
                  <div v-if="activeIndexs !== '任务发布'" class="dateof">
                    {{ item.putime }}
                  </div>
                  <div v-else class="dateof">{{ item.taskfbdate }}</div>
                  <div
                    class="dashed"
                    style="font-family: Arial, Helvetica, sans-serif"
                  ></div>
                  <img src="../assets/plussign.png" alt="" />
                  <div class="chaP" align="left">{{ item.name }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="Theheader-two">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <h4>人气课程</h4>
              <div @click="Popularityranking()" class="Popularityranking">
                查看更多>>
              </div>
            </div>

            <div class="inform-two">
              <ul>
                <li
                  class="Popularity"
                  v-for="(item, index) in Popularity"
                  :key="item.id"
                  @click="jump(item)"
                >
                  <img v-if="index === 0" src="../assets/trophy1.png" alt="" />
                  <img
                    v-if="index === 1"
                    src="../assets/Popularity2.png"
                    alt=""
                  />
                  <img
                    v-if="index === 2"
                    src="../assets/Popularity3.png"
                    alt=""
                  />
                  <div v-if="index > 2">{{ index }}</div>
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jkkp">
      <div class="cooperation-nav">
        <h4>健康科普</h4>
        <div class="viewmore" @click="CheckGogd()">查看更多>></div>
      </div>
      <div class="buttom">
        <ul class="Course">
          <li
            class="Live1"
            v-for="(iten, index) in tableData"
            :key="index"
            @click="jump1(iten)"
          >
            <video
              v-if="iten.sorts == '视频'"
              :poster="iten.picture ? iten.picture : commonIMG"
              class="videois"
              @click="jump1(iten)"
              :src="http + iten.video"
            ></video>
            <img
              v-else
              class="videois"
              :src="iten.picture ? iten.picture : commonIMG"
            />
            <i v-if="iten.sorts == '视频'" class="el-icon-video-play"></i>
            <div class="thevideo">
              <div style="display: flex">
                <div class="thename" @click="jump1(iten)">
                  {{ iten.name }}
                </div>
                <i
                  class="el-icon-star-on"
                  style="color: #f86626; font-size: 18px"
                >
                  {{ iten.score ? iten.score : 0 }}</i
                >
              </div>
              <p class="wb" @click="jump1(iten)" v-html="iten.content"></p>

              <div class="collection">
                <span class="dzs" @click="eacherpage(iten.userid)"
                  ><img class="imgssz" :src="http + iten.user.tx" alt="" />{{
                    iten.user.name
                  }}</span
                >
                <div class="jejq">
                  <!-- <span class="je">{{ iten.jg }}</span> -->
                  <div>
                    <i
                      style="font-size: 14px; color: #999999; line-height: 30px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ iten.ll }}</p>
                  </div>

                  <!-- <div>
                    <p class="dzs">{{ iten.knowdate }}</p>
                  </div> -->
                </div>
                <!-- <button
                    v-if="iten.jg !== '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即购买
                  </button>
                  <button
                    v-if="iten.jg == '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即查看
                  </button> -->
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 课程合作 -->
    <div class="cooperation">
      <div class="cooperation-one">
        <div class="cooperation-nav">
          <h4>课程合作</h4>
          <div class="cop">
            欢迎各界人士共同发扬中医文化！我们将在24小时内给您回复
          </div>
        </div>
        <div class="Input-box">
          <div class="inpts">
            <span>姓&nbsp;&nbsp;&nbsp;&nbsp;名&nbsp;:</span>
            <input type="text" v-model="name" />
          </div>
          <div class="interval"></div>
          <div class="inpts">
            <span style="width: 85px">联&nbsp;系&nbsp;方&nbsp;式&nbsp;:</span>
            <input type="text" v-model="phone" />
          </div>
        </div>
        <el-input
          class="input-area"
          maxlength="500"
          show-word-limit
          type="textarea"
          placeholder="请输入您的合作内容"
          v-model="hznr"
        >
        </el-input>

        <el-button @click="inskczs()" class="submit" v-preventReClick="3000"
          >提交</el-button
        >
      </div>
    </div>
    <!-- 联系方式 -->
    <!-- <div class="background">
      <div class="background-one">
        <div class="Course-navigation">
          <div class="navigation">
            <ul>
              <li>在线课程</li>
              <li>在线课程</li>
              <li>在线课程</li>
              <li>在线课程</li>
              <li>在线课程</li>
            </ul>
            <ul style="margin-left: 51px">
              <li>在线课程</li>
              <li>在线课程</li>
              <li>在线课程</li>
              <li>在线课程</li>
            </ul>
          </div>
          <div class="The-divider"></div>
          <div class="contact-manager">
            <div class="imgs-qr">
              <img src="../assets/qrcode.png" alt="" />
              <span>扫码添加</span>
            </div>
            <ul>
              <li>
                <img
                  style="width: 22px; height: 22px"
                  src="../assets/Contact-phone-number.png"
                  alt=""
                />
                <p>联系人: 靳先生</p>
              </li>
              <li>
                <img
                  style="width: 20px; height: 20px"
                  src="../assets/number-number.png"
                  alt=""
                />
                <p>电话: 136-2100-0732</p>
              </li>
              <li>
                <img
                  style="width: 19px; height: 15px"
                  src="../assets/Email-address.png"
                  alt=""
                />
                <p>邮箱: bjwlgk2018@163.com</p>
              </li>
              <li>
                <img
                  style="width: 19px; height: 19px"
                  src="../assets/Address-now.png"
                  alt=""
                />
                <p>地址: 北京市海淀区善缘街1号立方庭2-320</p>
              </li>
            </ul>
          </div>
          <div class="Cooperation-intention">
            <h4>课程合作</h4>
            <p>我们会在24小时内联系您</p>
            <input type="text" placeholder="请输入姓名" />
            <input
              type="text"
              placeholder="请输入联系方式"
              style="margin-top: 10px"
            />
            <span>提交</span>
          </div>
        </div>
        </div>
        <div class="Fortherecord">Copyright ©2018 北京蔚来高科技术有限公司（www.bjwlgk.com） 版权所有 | ICP经营许可证:京I</div>
    </div> -->
  </div>
</template>
<script>
// import { component } from 'vue/types/umd'
// @ is an alias to /src
// import navigation from '@/components/navigation.vue'
import {
  Shufflingfigure,
  inskcz,
  selpublic,
  selitemtj,
  selitem,
  seltask,
  selknow,
} from "../api/patient";
import Bus from "@/utils/bus";
export default {
  name: "Home",
  data() {
    return {
      Popularity: "",
      http: this.$store.state.https,
      templa: {},
      name: "",
      phone: "",
      hznr: "",
      activeIndexs: "任务发布",
      figure: [
        { img: require("../assets/figure1.png") },
        { img: require("../assets/figure2.png") },
        { img: require("../assets/figure3.png") },
        { img: require("../assets/figure4.png") },
        { img: require("../assets/figure5.png") },
      ],
      notice: {},
      tableData: [],
      commonIMG: require("../assets/common/jkkp.png"),
    };
  },
  created() {
    this.Shufflingfigures();
    this.recommended();
    if (this.activeIndexs !== "") {
      this.handleSelects(this.activeIndexs);
    }
    this.selitemiss();
    this.selitemis();
    // console.log(this.$state.dispatch('initTest'))
  },
  mounted() {
    Bus.$emit("activeRouter", "/home");
  },
  methods: {
    async selitemis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 10);
      data.append("status", "已通过");
      var res = await selknow(data);
      this.tableData = res.records;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].sorts == "视频") {
          this.tableData[i].picture = this.http + this.tableData[i].picture;
        }
        // this.tableData[i].pf = Number(this.tableData[i].pf);
      }
    },
    // 人气跳转
    Popularityranking() {
      this.$router.push("/ropularity");
    },
    //科普查看更多
    CheckGogd() {
      this.$router.push("/HealthSciencePopularization");
    },
    // 人气排行
    selitemiss() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 10);
      data.append("px", "浏览倒");
      data.append("status", "已发布");
      selitem(data).then((res) => {
        this.Popularity = res.rows;
      });
    },
    // 跳转老师页面
    eacherpage(item) {
      this.$router.push(`/TeacherDetailsPage/${item}`);
    },
    // /跳转
    jump1(item) {
      this.$store.commit("Jumpfordetails", item.id);
      if (item.sorts == "视频") {
        this.$router.push("/PopularScienceDetails");
      } else {
        this.$router.push("/ArticleDetails");
      }
      window.scrollTo({
        top: 1,
      });
    },
    // 跳转到详情页课程
    jump(item) {
      this.$router.push("/coursedetailspage");
      this.$store.commit("Jumpfordetails", item.id);
      console.log(this.$store.state.hometz);
      this.$store.commit("homres", 1);
      window.scrollTo({
        top: 1,
      });
    },
    // 跳转课程页
    classification() {
      this.$router.push("/myinformation");
    },
    // 首页推荐视频
    recommended() {
      this.$nextTick(() => {
        selitemtj().then((res) => {
          console.log(res);
          this.templa = res;
        });
      });
    },
    // 进入列表
    Checkthelist() {
      this.$router.push(`/Newslist/${this.activeIndexs}`);
    },
    // 跳转到详情页
    Jumpfordetails(item) {
      this.$router.push(`/Informdetails/${item}`);
      // console.log(this.activeIndexs)
      this.$store.commit("zxxixvt", this.activeIndexs);
    },
    // 课程合作接口
    inskczs() {
      var ss = this.phone;
      var a = ss.split("");
      if (this.name !== "" && a.length === 11 && this.hznr !== "") {
        var data = new FormData();
        data.append("name", this.name);
        data.append("phone", this.phone);
        data.append("hznr", this.hznr);
        inskcz(data).then((rem) => {
          if (rem.code === "OK") {
            this.$message({
              showClose: true,
              message: rem.msg,
              type: "success",
            });
            this.phone = "";
            this.name = "";
            this.hznr = "";
          }
        });
      } else {
        if (this.hznr === "") {
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
        } else if (a.length !== 11) {
          this.$message({
            showClose: true,
            message: "请填写完整手机号码",
            type: "warning",
          });
        } else if (this.name === "") {
          this.$message({
            showClose: true,
            message: "请填写完整姓名",
            type: "warning",
          });
        }
      }
    },
    // 轮播图
    Shufflingfigures() {
      const data = new FormData();
      Shufflingfigure(data).then((res) => {
        this.figure = res;
        this.figure.map((item) => {
          item.photo = this.$store.state.https + item.photo;
        });
      });
    },

    // Announcements () {
    //   selpublic().then(res => {
    //   })
    // },
    // 咨询信息
    async handleSelects(key, keyPath) {
      if (key === "通知公告" || key === "新闻动态") {
        this.activeIndexs = key;
        const data = new FormData();
        data.append("sort", this.activeIndexs);
        data.append("page", 1);
        data.append("rows", 7);
        await selpublic(data).then((res) => {
          this.notice = res.rows;
        });
      }
      if (key === "任务发布") {
        this.activeIndexs = key;
        const data = new FormData();
        data.append("status", "已发布");
        data.append("page", 1);
        data.append("rows", 7);
        await seltask(data).then((res) => {
          this.notice = res.records;
        });
      }
    },
  },

  components: {
    // navigation
  },
};
</script>
<style scoped lang="scss">
.home {
  width: 100%;
  background: #fff;
  .shuffling {
    width: 100%;
    .el-carousel {
      width: 100%;
      height: 560px;
    }
  }
  .course {
    width: 1190px;
    margin: 0 auto;
    display: flex;
    // background: rgb(193, 190, 216);
    flex-direction: column;
    .csada {
      padding: 44px 50px 0px 50px;
      .Livecourses {
        width: 100%;
        min-height: 300px;
        .classification {
          display: flex;
          justify-content: space-between;
          line-height: 100%;
          margin-bottom: 19px;
          p {
            // width: 90px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin: 0px;
            cursor: pointer;
          }
          span {
            display: flex;
            // width: 110px;
            height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #4ccaff;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.jkkp {
  width: 1190px;
  margin: 0 auto;
  // display: flex;
  .cooperation-nav {
    padding: 48px 50px 2px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 80px;
    h4 {
      // width: 90px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .cop {
      // width: 440px;
      // height: 16px;
      font-size: 15px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 800;
      color: #cecece;
      line-height: 30px;
      margin-left: 20px;
    }
  }
  .buttom {
    margin-top: 27px;

    .Course {
      display: flex;
      width: 100%;
      justify-content: left;
      flex-wrap: wrap;
      .Live1 {
        display: flex;
        width: 530px;
        height: 120px;
        background: #ffffff;
        border: 1px solid #f6f6f6;
        border-radius: 6px;
        margin-bottom: 20px;
        transition: all 0.2s;
        margin-left: 17px;
        .el-icon-video-play {
          font-size: 40px;
          position: absolute;
          margin-left: 50px;
          margin-top: 25px;
          color: #ffffff;
          opacity: 0.5;
        }
        .thevideo {
          // width: 100%;
          display: flex;
          flex-direction: column;
          padding: 10px 10px;
          .thename {
            font-size: 15px;
            // height: 48px;
            width: 300px;
            text-align: left;
            font-weight: bold;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .wb {
            display: flex;
            text-align: left;
            margin-top: 3px;
            width: 350px;
            height: 58px;
            cursor: pointer;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 2; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
            font-size: 12px;
            line-height: 24px;
          }

          .collection {
            height: 26px;
            padding-top: 0px;
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // border-top: 2px solid #f6f6f6;
            .jejq {
              // margin-top: 3px;
              // display: flex;
              justify-content: space-between;
              line-height: 26px;
              align-items: center;

              .je {
                // width: 66px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ff1616;
              }
              div {
                display: flex;
                img {
                  width: 12px;
                  height: 12px;
                  line-height: 12px;
                  margin-right: 8px;
                  padding-top: 2px;
                }
                .dzs {
                  font-size: 12px;
                  margin-left: 5px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #999999;
                }
              }
            }
            .dzs {
              cursor: pointer;
              white-space: nowrap;
              // height: 13px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999;
            }
            .Buynow {
              cursor: pointer;
              white-space: nowrap;
              // display: flex;
              text-align: center;
              width: 67px;
              height: 23px;
              background: #4ccaff;
              border-radius: 4px;
              border: 1px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
            }
            .Buynow:hover {
              background: #4ccaffc9;
            }
          }
        }
      }
      .Live1:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
      }
    }
    .el-pagination {
      margin-top: 60px;
      margin-bottom: 30px;
    }
  }
}
.Course {
  display: flex;
  width: 96%;
  margin: auto;
  // justify-content: space-between;
  flex-wrap: wrap;
  .Live1 {
    margin-right: 5px;
    margin-left: 5px;
    width: 247px;
    height: 299px;
    background: #ffffff;
    border: 1px solid #ededed;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.2s;
    .thevideo {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      .theh4 {
        cursor: pointer;
        height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 15px;
        width: 220px;
        text-align: left;
      }
      .wb {
        cursor: pointer;
        display: flex;
        text-align: left;
        margin-top: 12px;
        width: 200px;
        height: 38px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 2; /**显示的行数**/

        overflow: hidden; /**隐藏超出的内容**/
      }
      .jejq {
        margin-top: 9px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .je {
          width: 66px;
          text-align: left;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          img {
            width: 12px;
            height: 12px;
            line-height: 12px;
            margin-right: 8px;
            padding-top: 2px;
          }
          .dzs {
            margin-left: 5px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .collection {
        // height: 40px;
        border-top: 2px solid #f6f6f6;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        .dzs {
          cursor: pointer;
          white-space: nowrap;
          height: 13px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          img {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .Buynow {
          white-space: nowrap;
          cursor: pointer;
          // display: flex;
          text-align: center;
          width: 67px;
          height: 23px;
          background: #4ccaff;
          border-radius: 4px;
          border: 1px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
        .Buynow:hover {
          background: #4ccaffc9;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.Allcourses {
  width: 99px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
}
.information {
  width: 1190px;
  // height: 500px;
  margin: 0 auto;
  display: flex;
  // background: rgb(193, 190, 216);
  flex-direction: column;
  padding-top: 33px;
  .inform {
    padding: 0 50px;
    // background: #e6d5d5;
  }
}
.inform-one {
  display: flex;
  // 咨询信息
  .Theheader {
    width: 500px;
    h4 {
      display: flex;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .notice {
      // background: #bdc1eb;
      // margin-left: 50px;
      width: 577px;
      .el-menu-demo {
        display: flex;
        width: 250px;
        margin-left: 63px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        border-bottom: solid 0px #e6e6e6;
        margin-bottom: 28px;
        img {
          width: 12px;
          height: 12px;
          margin-top: 32%;
          margin-right: 10px;
        }
      }
      ul {
        .change:hover {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #4ccaff;
          // margin-top: 20px;

          .dateof {
            color: #4ccaff;
          }
          img {
            width: 19px;
            height: 19px;
            margin-right: 18px;
            line-height: 40px;
          }
          p {
            color: #4ccaff;
          }
        }

        // margin-top: 45px;
        li {
          // position: relative;
          cursor: pointer;
          display: flex;
          // margin-bottom: 20px;

          .dateof {
            font-size: 16px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: #333333;
            margin-right: 19px;
            white-space: nowrap;
          }
          img {
            width: 19px;
            height: 19px;
            margin-right: 18px;
            // z-index:10
          }
          .chaP {
            // width: 100px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 400px;
          }
          .chaP:hover {
            color: #4ccaff;
          }
        }

        .dashed {
          position: relative;
          left: 10px;
          top: -10px;
          height: 40px;
          border: 1px dashed #bfbfbf;
        }
      }
    }
  }
  // 人气排行
  .Theheader-two {
    width: 500px;
    margin-left: 114px;
    h4 {
      display: flex;
      // width: 90px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      // padding-bottom: 20px;
    }
    .inform-two {
      margin-top: 20px;
      // padding: 20px 22px;
      background: #ffffff;
      // border: 1px solid #ededed;
      border-radius: 6px;
      font-size: 16px;
      ul {
        min-height: 360px;
      }
      .Popularity {
        cursor: pointer;
        text-align: left;
        display: flex;
        margin-bottom: 16px;
        img {
          width: 19px;
          height: 16px;
          margin-right: 8px;
        }
        div {
          width: 19px;
          height: 16px;
          // font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          // line-height: px;
          margin-right: 8px;
        }

        p {
          width: 450px;
          // height: 14px;
          // font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 1; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }
      }
      .Popularity:hover p {
        color: #4ccaff;
      }
    }
  }
}

.Popularityranking {
  // width: 71px;
  // height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
}
.cooperation {
  width: 1190px;
  // height: 500px;
  // background: red;
  margin: 0 auto;
  display: flex;
  .cooperation-one {
    // width: 100%;
    padding: 48px 50px 2px 50px;
    // display: flex;
    margin-bottom: 80px;
    .cooperation-nav {
      display: flex;
      h4 {
        // width: 90px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .cop {
        // width: 440px;
        // height: 16px;
        font-size: 15px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 800;
        color: #cecece;
        line-height: 30px;
        margin-left: 20px;
      }
    }
    .Input-box {
      margin-top: 20px;
      display: flex;
      .interval {
        width: 23px;
      }
      .inpts {
        width: 509px;
        height: 50px;
        background: #ffffff;
        border: 1px solid #dedede;
        border-radius: 10px;
        display: flex;
        span {
          width: 52px;
          height: 16px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 49.6px;
          padding-left: 32px;
          padding-right: 15px;
        }
        input {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          width: 80%;
          border: 0;
          border-radius: 10px;
          font-size: 18px;
        }
      }
    }
  }
}
.input-area {
  margin-top: 20px;
}
::v-deep.el-textarea .el-input__count {
  right: 60px;
}
.el-textarea ::v-deep .el-textarea__inner {
  padding: 20px 30px;
  width: 1041px;
  height: 209px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 10px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  overflow: hidden;
  overflow: hidden;
  resize: none !important;
  padding: 20px 30px;
}
.submit {
  padding: 0px;
  width: 70px;
  height: 30px;
  line-height: 30px;
  background: #4ccaff;
  cursor: pointer;
  margin: auto;
  margin-top: 29px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  border-radius: 5px;
}
.el-button:active {
  border-color: #4ccaff;
}
// .background {
//   // display: flex;
//   margin-top: 81px;
//   width: 100%;
//   height: 309px;
//   background: url("../assets/background1.png");
//   .background-one {
//     width: 1190px;
//     display: flex;
//     margin: 0 auto;
//     .Course-navigation {
//       width: 100%;
//       padding-left: 50px;
//       padding-right: 50px;
//       padding-top: 55px;
//       display: flex;
//       .navigation {
//         display: flex;
//         // margin-top: 50px;
//         ul {
//           height: 167px;
//           font-size: 16px;
//           font-family: Source Han Sans CN;
//           font-weight: 400;
//           color: #999999;
//           line-height: 38px;
//           li{
//             display: flex;
//           }
//         }
//       }
//       .The-divider {
//         width: 1px;
//         height: 164px;
//         background: #999999;
//         margin-left: 50px;
//         // margin-top: 56px;
//       }
//       .contact-manager {
//         // margin-top: 58px;
//         margin-left: 43px;
//         display: flex;
//         .imgs-qr {
//           display: flex;
//           flex-direction: column;
//           span {
//             font-size: 16px;
//             font-family: Source Han Sans CN;
//             font-weight: 400;
//             color: #cccccc;
//             margin-top: 14px;
//           }
//         }
//         ul {
//           margin-left: 38px;
//           li {
//             display: flex;
//             margin-bottom: 27px;
//             font-size: 16px;
//             font-family: Source Han Sans CN;
//             font-weight: 400;
//             color: #d6d6d6;
//             // line-height: 46px;
//             p {
//               margin-left: 19px;
//             }
//           }
//         }
//       }
//       .Cooperation-intention {
//         // margin-top: 58px;
//         display: flex;
//         flex-direction: column;
//         text-align: left;
//         margin-left: 47px;
//         h4 {
//           font-size: 16px;
//           font-family: Source Han Sans CN;
//           font-weight: 400;
//           color: #f0f0f0;
//         }
//         p {
//           margin-top: 9px;
//           font-size: 14px;
//           font-family: Source Han Sans CN;
//           font-weight: 400;
//           color: #999999;
//           margin-bottom: 16px;
//         }
//         input {
//           width: 227px;
//           height: 40px;
//           background: #999999;
//           opacity: 0.4;
//           border-radius: 6px;
//           color: #999999;
//         }
//         span {
//           margin-left: 20px;
//           margin-top: 11px;
//           font-size: 16px;
//           font-family: Source Han Sans CN;
//           font-weight: 400;
//           color: #4ccaff;
//         }
//       }
//     }
//   }
// }
// .Fortherecord{
//   // display: flex;
//   margin-top: 25px;
//    font-size: 14px;
//   font-family: Source Han Sans CN;
//   font-weight: 400;
//   color: #D6D6D6;

// }
.viewmore {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
  // margin-top: px;
}
.videois {
  width: 134px;
  height: 100px;
  padding: 10px;
  object-fit: contain;
}
@media (max-width: 768px) {
  .home {
    width: 100%;
    background: #fff;
    .shuffling {
      width: 100%;
      .el-carousel {
        width: 100%;
        height: 160px;
      }
    }
    .course {
      width: 100vw;
      // margin: 0 auto;
      display: flex;
      // background: rgb(193, 190, 216);
      flex-direction: column;
      .csada {
        padding: 10px;
        .Livecourses {
          width: 98vw;
          min-height: 150px;
          .classification {
            display: flex;
            justify-content: space-between;
            line-height: 100%;
            margin-bottom: 10px;
            p {
              // width: 90px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #333333;
              margin: 0px;
              cursor: pointer;
            }
            span {
              display: flex;
              // width: 110px;
              height: 14px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #4ccaff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .videois {
    width: 110px;
    height: 80px;
    object-fit: contain;
  }
  .jkkp {
    width: 100vw;
    margin: 0 auto;
    // display: flex;
    .cooperation-nav {
      padding: 48px 0px 2px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-bottom: 80px;
      h4 {
        // width: 90px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .cop {
        // width: 440px;
        // height: 16px;
        font-size: 15px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 800;
        color: #cecece;
        line-height: 30px;
        margin-left: 20px;
      }
    }
    .buttom {
      margin-top: 27px;

      .Course {
        display: flex;
        width: 100%;
        justify-content: left;
        flex-wrap: wrap;
        .Live1 {
          display: flex;
          width: 95vw;
          height: 100px;
          background: #ffffff;
          border: 1px solid #f6f6f6;
          border-radius: 6px;
          margin-bottom: 20px;
          transition: all 0.2s;
          margin-left: 17px;
          .el-icon-video-play {
            font-size: 30px;
            position: absolute;
            margin-left: 40px;
            margin-top: 25px;
            color: #ffffff;
            opacity: 0.5;
          }
          .thevideo {
            // width: 100%;
            display: flex;
            flex-direction: column;
            padding: 6px 6px;
            .thename {
              font-size: 15px;
              // height: 48px;
              width: 40vw;
              text-align: left;
              font-weight: bold;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .wb {
              display: flex;
              text-align: left;
              margin-top: 3px;
              width: 55vw;
              height: 58px;
              cursor: pointer;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              display: -webkit-box; /**对象作为伸缩盒子模型展示**/
              -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
              -webkit-line-clamp: 1; /**显示的行数**/
              overflow: hidden; /**隐藏超出的内容**/
              font-size: 12px;
              line-height: 26px;
            }

            .collection {
              height: 26px;
              padding-top: 0px;
              margin-top: 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              // border-top: 2px solid #f6f6f6;
              .jejq {
                // margin-top: 3px;
                // display: flex;
                justify-content: space-between;
                line-height: 26px;
                align-items: center;

                .je {
                  // width: 66px;
                  font-size: 12px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #ff1616;
                }
                div {
                  display: flex;
                  margin-top: 5px;
                  img {
                    width: 12px;
                    height: 12px;
                    line-height: 12px;
                    margin-right: 8px;
                    padding-top: 2px;
                  }
                  .dzs {
                    font-size: 12px;
                    margin-left: 5px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                  }
                }
              }
              .dzs {
                cursor: pointer;
                white-space: nowrap;
                // height: 13px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999;
              }
              .Buynow {
                cursor: pointer;
                white-space: nowrap;
                // display: flex;
                text-align: center;
                width: 67px;
                height: 23px;
                background: #4ccaff;
                border-radius: 4px;
                border: 1px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
              }
              .Buynow:hover {
                background: #4ccaffc9;
              }
            }
          }
        }
        .Live1:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
        }
      }
      .el-pagination {
        margin-top: 60px;
        margin-bottom: 30px;
      }
    }
  }
  .Course {
    display: flex;
    width: 95vw;
    margin: auto;
    // justify-content: space-between;
    flex-wrap: wrap;
    .Live1 {
      margin-right: 5px;
      margin-left: 5px;
      width: 44vw;
      height: 269px;
      background: #ffffff;
      border: 1px solid #ededed;
      border-radius: 6px;
      margin-bottom: 20px;
      transition: all 0.2s;
      .thevideo {
        display: flex;
        flex-direction: column;
        padding: 5px;
        .theh4 {
          cursor: pointer;
          width: 40vw;
          height: 18px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap; //溢出用省略号显示
          text-align: left;
        }
        .wb {
          cursor: pointer;
          display: flex;
          text-align: left;
          margin-top: 12px;
          width: 40vw;
          height: 35px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          // line-height: 19px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .jejq {
          margin-top: 9px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .je {
            width: 66px;
            text-align: left;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ff1616;
          }
          div {
            display: flex;
            img {
              width: 12px;
              height: 12px;
              line-height: 12px;
              margin-right: 8px;
              padding-top: 2px;
            }
            .dzs {
              margin-left: 5px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
            }
          }
        }
        .collection {
          // height: 40px;
          border-top: 2px solid #f6f6f6;
          padding-top: 10px;
          display: flex;
          justify-content: space-between;
          .dzs {
            cursor: pointer;
            white-space: nowrap;
            height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            img {
              width: 22px;
              height: 22px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .Buynow {
            white-space: nowrap;
            cursor: pointer;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .Buynow:hover {
            background: #4ccaffc9;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .Allcourses {
    width: 99px;
    height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    cursor: pointer;
  }
  .information {
    width: 100vw;
    // height: 500px;
    margin: 0 auto;
    display: flex;
    // background: rgb(193, 190, 216);
    flex-direction: column;
    padding-top: 0px;
    .inform {
      padding: 0 10px;
      // background: #e6d5d5;
    }
  }
  .inform-one {
    display: block;
    // 咨询信息
    .Theheader {
      width: 100vw;
      h4 {
        display: flex;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .notice {
        // background: #bdc1eb;
        margin-left: 10px;
        width: 90vw;
        .el-menu-demo {
          display: flex;
          width: 250px;
          margin-left: 0vw;
          img {
            width: 12px;
            height: 12px;
            margin-top: 32%;
            margin-right: 10px;
          }
        }
        ul {
          .change:hover {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #4ccaff;
            // margin-top: 20px;

            .dateof {
              color: #4ccaff;
            }
            img {
              width: 19px;
              height: 19px;
              margin-right: 18px;
              line-height: 40px;
            }
            .chaP {
              color: #4ccaff;
            }
          }

          // margin-top: 45px;
          li {
            // position: relative;
            cursor: pointer;
            display: flex;
            // margin-bottom: 20px;

            .dateof {
              font-size: 16px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: #333333;
              margin-right: 19px;
              white-space: nowrap;
            }
            img {
              width: 19px;
              height: 19px;
              margin-right: 18px;
              // z-index:10
            }
            .chaP {
              width: 60vw;
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              white-space: nowrap;
              text-overflow: ellipsis;
              /*隐藏多余的部分*/
              overflow: hidden;
              // display: -webkit-box;
              // -webkit-box-orient: vertical;
              // -webkit-line-clamp: 1;
            }
          }

          .dashed {
            position: relative;
            left: 10px;
            top: -10px;
            height: 40px;
            border: 1px dashed #bfbfbf;
          }
        }
      }
    }
    // 人气排行
    .Theheader-two {
      width: 95vw;
      margin: 0px;
      h4 {
        display: flex;
        margin-bottom: 0px;
      }
      .inform-two {
        padding: 20px 22px;
        background: #ffffff;
        border: 1px solid #ededed;
        border-radius: 6px;
        ul {
          min-height: 360px;
        }
        .Popularity {
          cursor: pointer;
          text-align: left;
          display: flex;
          margin-bottom: 16px;
          img {
            width: 19px;
            height: 16px;
            margin-right: 8px;
          }
          div {
            width: 19px;
            height: 16px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            // line-height: px;
            margin-right: 8px;
          }

          p {
            width: 210px;
            // height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 1; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
          }
        }
        .Popularity:hover p {
          color: #4ccaff;
        }
      }
    }
  }

  .Popularityranking {
    display: none;
  }
  .cooperation {
    width: 100vw;
    // height: 500px;
    // background: red;
    margin: 0 auto;
    display: flex;
    .cooperation-one {
      // width: 100%;
      padding: 10px;
      // display: flex;
      margin-bottom: 80px;
      .cooperation-nav {
        display: flex;
        h4 {
          // width: 90px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
        .cop {
          width: 70vw;
          // height: 16px;
          font-size: 15px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: #cecece;
          line-height: 30px;
          margin-left: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .Input-box {
        margin-top: 20px;
        display: block;
        .interval {
          width: 23px;
        }
        .inpts {
          width: 95vw;
          height: 50px;
          margin-top: 10px;
          background: #ffffff;
          border: 1px solid #dedede;
          border-radius: 10px;
          display: flex;
          span {
            width: 52px;
            height: 16px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            line-height: 49.6px;
            padding-left: 32px;
            padding-right: 15px;
          }
          input {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            line-height: 21px;
            width: 80%;
            border: 0;
            border-radius: 10px;
            font-size: 18px;
          }
        }
      }
    }
  }
  .input-area {
    margin-top: 20px;
  }
  ::v-deep.el-textarea .el-input__count {
    right: 60px;
  }
  .el-textarea ::v-deep .el-textarea__inner {
    padding: 20px 30px;
    width: 1041px;
    height: 209px;
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
    overflow: hidden;
    overflow: hidden;
    resize: none !important;
    padding: 20px 30px;
  }
  .submit {
    padding: 0px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    background: #4ccaff;
    cursor: pointer;
    margin: auto;
    margin-top: 29px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    border-radius: 5px;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
  .viewmore {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    cursor: pointer;
    // margin-top: px;
  }
}
</style>
<style scoped>
.el-textarea >>> .el-textarea__inner {
  width: 1041px;
  height: 209px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 10px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  overflow: hidden;
  overflow: hidden;
  resize: none !important;
}
.el-carousel >>> .el-carousel__container {
  width: 100%;
  height: 560px;
}
.el-carousel__container img {
  width: 100%;
  height: 560px;
}

.videshome {
  width: 247px;
  height: 138px;
  border-radius: 6px 6px 0px 0px;
  object-fit: cover;
}
@media (max-width: 768px) {
  .el-carousel >>> .el-carousel__container {
    width: 100%;
    height: 160px;
  }
  .el-carousel__container img {
    width: 100%;
    height: 160px;
  }
  .videshome {
    width: 44vw;
    height: 108px;
    border-radius: 6px 6px 0px 0px;
    object-fit: cover;
  }
  .el-textarea >>> .el-textarea__inner {
    width: 95vw;
    height: 209px;
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
    overflow: hidden;
    overflow: hidden;
    resize: none !important;
  }
}
</style>
